var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "visitor-activities" },
    [
      _c("ActivityListView", {
        attrs: { activities: _vm.activities, loading: _vm.loading },
        on: { "load-more": _vm.loadMore },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }